document.addEventListener("DOMContentLoaded", function () {
  let SwiperTop = new Swiper(".block__detail-banner-review-slider", {
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
    mousewheel: { forceToAxis: true },
    disableOnInteraction: true,
    slidesPerView: "auto",
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
    speed: 2500,
    allowTouchMove: false,
    breakpoints: {
      1200: {
        spaceBetween: 60,
      },
      991: {
        spaceBetween: 40,
      },
    },
  });
});
